import { render, staticRenderFns } from "./DiscountTable.vue?vue&type=template&id=0d72a6e6&"
import script from "./DiscountTable.vue?vue&type=script&lang=js&"
export * from "./DiscountTable.vue?vue&type=script&lang=js&"
import style0 from "./DiscountTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d72a6e6')) {
      api.createRecord('0d72a6e6', component.options)
    } else {
      api.reload('0d72a6e6', component.options)
    }
    module.hot.accept("./DiscountTable.vue?vue&type=template&id=0d72a6e6&", function () {
      api.rerender('0d72a6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiscountTable.vue"
export default component.exports